// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vss-Persona .vss-Persona-content {
  border-radius: 50%;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  color: white;
  background-color: rgba( 166, 166, 166 ,  1 );
  background-color: rgba( var(--palette-neutral-30,166, 166, 166) ,  1 );
  user-select: none;
}
.vss-Persona .vss-Persona-content.using-image {
  object-fit: cover;
  background-color: transparent;
}
.vss-Persona .vss-Persona-content.extra-extra-small {
  font-size: 0.6875rem;
  line-height: 15px;
}
.vss-Persona .vss-Persona-content.extra-small {
  font-size: 0.6875rem;
  line-height: 17px;
}
.vss-Persona .vss-Persona-content.extra-small-plus {
  font-size: 0.6875rem;
  line-height: 19px;
}
.vss-Persona .vss-Persona-content.small {
  font-size: 0.6875rem;
  line-height: 24px;
}
.vss-Persona .vss-Persona-content.small-plus {
  font-size: 0.875rem;
  line-height: 27px;
}
.vss-Persona .vss-Persona-content.medium {
  font-size: 0.875rem;
  line-height: 31px;
}
.vss-Persona .vss-Persona-content.medium-plus {
  font-size: 0.875rem;
  line-height: 39px;
}
.vss-Persona .vss-Persona-content.large {
  font-size: 17px;
  line-height: 46px;
}
.vss-Persona .vss-Persona-content.extra-large {
  font-size: 1.75rem;
  line-height: 70px;
}
.vss-Persona .vss-Persona-content.extra-extra-large {
  font-size: 2.5rem;
  line-height: 98px;
}
.vss-Persona.extra-extra-small {
  width: 16px;
  height: 16px;
}
.vss-Persona.extra-small {
  width: 18px;
  height: 18px;
}
.vss-Persona.extra-small-plus {
  width: 20px;
  height: 20px;
}
.vss-Persona.small {
  width: 24px;
  height: 24px;
}
.vss-Persona.small-plus {
  width: 28px;
  height: 28px;
}
.vss-Persona.medium {
  width: 32px;
  height: 32px;
}
.vss-Persona.medium-plus {
  width: 40px;
  height: 40px;
}
.vss-Persona.large {
  width: 48px;
  height: 48px;
}
.vss-Persona.extra-large {
  width: 72px;
  height: 72px;
}
.vss-Persona.extra-extra-large {
  width: 100px;
  height: 100px;
}

/*# sourceMappingURL=VssPersona.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/VssPersona/VssPersona.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/VssPersona/VssPersona.css"],"names":[],"mappings":"AAEI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EAEA,uBAAA;EAEA,YAAA;EACA,4CCyDK;EDxDL,sEAAA;EEHN,iBAAiB;AFKX;AEHR;EFKY,iBAAA;EEHV,6BAA6B;AFQvB;AENR;EFQY,oBAAA;EENV,iBAAiB;AFQX;AENR;EFQY,oBAAA;EENV,iBAAiB;AFQX;AENR;EFQY,oBAAA;EENV,iBAAiB;AFQX;AENR;EFQY,oBAAA;EENV,iBAAiB;AFQX;AENR;EFQY,mBAAA;EENV,iBAAiB;AFQX;AENR;EFQY,mBAAA;EENV,iBAAiB;AFQX;AENR;EFQY,mBAAA;EENV,iBAAiB;AFQX;AENR;EFQY,eAAA;EENV,iBAAiB;AFQX;AENR;EFQY,kBAAA;EENV,iBAAiB;AFQX;AENR;EFQY,iBAAA;EENV,iBAAiB;AFUf;AERJ;EFUQ,WAAA;EERN,YAAY;AFUV;AERJ;EFUQ,WAAA;EERN,YAAY;AFUV;AERJ;EFUQ,WAAA;EERN,YAAY;AFUV;AERJ;EFUQ,WAAA;EERN,YAAY;AFUV;AERJ;EFUQ,WAAA;EERN,YAAY;AFUV;AERJ;EFUQ,WAAA;EERN,YAAY;AFUV;AERJ;EFUQ,WAAA;EERN,YAAY;AFUV;AERJ;EFUQ,WAAA;EERN,YAAY;AFUV;AERJ;EFUQ,WAAA;EERN,YAAY;AFUV;AERJ;EFUQ,YAAA;EERN,aAAa;AACf;;AAEA,yCAAyC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
